export default {
  independentMarketing: {
    common: {
      requestFailed: '인터페이스 요청 실패',
      hintSelect: '선택하다',
      hintInput: '입력하다',
      submit: '제출하다',
      cancel: '취소',
      confirm: '좋아요',
    },
    agreement: {
      title: 'Autel 독립 딜러 등록 계약',
      nextBtn: '다음',
      getAgreementFailed: '계약 내용을 가져오지 못했습니다.',
    },
    successPage: {
      title:
        '귀하의 신청서 정보가 성공적으로 제출되었으며 검토 결과는 영업일 기준 15일 이내에 $1 이메일로 전송됩니다. 자세한 내용은 받은 편지함을 확인하세요.',
      subTitle: '$1초 후에 홈 페이지로 돌아갑니다.',
    },
    applyTitle: '귀하는 Autel 독립 딜러가 되기 위해 지원하고 있습니다. 다음 정보를 정확하게 입력해 주세요.',
    companyName: '회사명',
    companyTax: '부가 가치세 ID',
    userCountry: '나라',
    legalPerson: '법률 고문',
    contactEmail: '이메일 연락처',
    contactEmailTips:
      '이 이메일 주소는 검토 결과 이메일의 연락처가 됩니다. 검토가 승인되면 독립 딜러 관리 시스템의 로그인 계정 이름으로도 사용됩니다.',
    corporateIdentity: '법률고문 아이디',
    uploadTips: 'JPG, JPEG, PNG, PDF(20MB 이하)',
    businessLicense: '사업 허가증',
    emailErrorTips: '유효한 이메일을 입력하세요.',
    uploadPic: '이미지 업로드',
    picMaxLimit: '최대 이미지 크기는 20MB입니다. 다시 선택해 주세요.',
  },
};
